module.exports = __webpack_public_path__ + "img/chemical_engineer_stats.f67bbfc0.png";